import {BarGraph as Base} from './base'
import {doc} from './doc'

export const BarGraph = doc(Base)
